import React, { useState, useEffect } from "react";
import { TERMS_LIST_URL } from "../../utils/urls";
import instance from "../../services/services";
import { useLanguage } from "../../hooks/useLanguage";

function TermsOfService(){
  const { t } = useLanguage();
  const [termsList, setTermsList] = useState([]);
  useEffect(() => {
      const fetchTermsList = async () => {
          try {
              const response = await instance.post(TERMS_LIST_URL);
              setTermsList(response.data.data.agreement)

          } catch (error) {
              console.error('약관 목록 가져오기 실패', error);
          }
      };
      fetchTermsList();
  }, []);

  return(
    <section className="guide_section benefit_section">
      <h3 className="commu_title noline">{t('equipment_return_completed2')}</h3>
      <div className='terms_list_about '>
          <div dangerouslySetInnerHTML={{ __html: termsList }} /> 
      </div>

    </section>
  )
};

export default TermsOfService;